/**
 * Renata Mini PWA — Config / Personality at /renata/config
 */
import { createFileRoute } from "@tanstack/react-router";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";
import { RenataConfig } from "@/components/renata/RenataConfig";

export const Route = createFileRoute("/renata/config")({
  component: RenataMiniConfig,
  head: () => ({ meta: [{ title: "Renata — Configuración" }] }),
});

function RenataMiniConfig() {
  const tenantId = useWorkspaceTenantId();
  if (!tenantId) return null;

  return (
    <div className="overflow-y-auto h-full">
      <div className="px-4 py-4">
        <h2 className="font-semibold text-sm">Configuración de Renata</h2>
        <p className="mb-4 text-xs text-muted-foreground">
          Personalizá el tono y estilo de la asistente.
        </p>
        <RenataConfig tenantId={tenantId} />
      </div>
    </div>
  );
}
